module.exports = __webpack_public_path__ + "static/feathr-0.16fcf69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feathr/feathr-0.png
// module id = 484
// module chunks = 33212578467737